<template>
  <CModal
    @mtdclosemodal="mtdClose"
    :show="boo_modal"
    :close-on-backdrop="false"
    :centered="false"
    :title="title"
    :size="'lg'"
    :btn_cancel="true"
    :btn_ok="true"
    :booTitile="true"
    :fullScreen="false"
  >
    <div class="row d-flex">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <label class="mb-3 mt-2">Categoria</label>
        <div class="input-group input-group-sm">
          <div class="input-group-text">
            <span
              style="font-size: 20px; border: none"
              class="input-group-text"
            >
              <i class="fa fa-medkit"></i>
            </span>
          </div>
          <select
            class="form-control form-control-sm"
            aria-label="Default select example"
            v-model="data_detail.categorie_id"
            @change="fetchSubcategories"
          >
            <option disabled selected value="">Seleccione...</option>
            <option
              v-for="(item, index) in dataCategories"
              :key="index"
              :value="item.id"
            >
              {{ item.name }}
            </option>
          </select>
        </div>
      </div>

      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <label class="mb-3 mt-2">SubCategoria</label>
        <div class="input-group input-group-sm">
          <div class="input-group-text">
            <span
              style="font-size: 20px; border: none"
              class="input-group-text"
            >
              <i class="fa fa-briefcase-medical"></i>
            </span>
          </div>
          <select
            class="form-control form-control-sm"
            aria-label="Default select example"
            v-model="data_detail.subcategorie_id"
          >
            <option disabled selected value="">Seleccione...</option>
            <option
              v-for="(item, index) in dataSubSub"
              :key="index"
              :value="item.id"
            >
              {{ item.name }}
            </option>
          </select>
        </div>
      </div>

      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <label class="mb-3 mt-2">Servicio Específico</label>
        <div class="input-group input-group-sm">
          <div class="input-group-text">
            <span style="font-size: 20px; border: none">
              <i class="fa fa-briefcase-medical"></i>
            </span>
          </div>
          <input
            type="text"
            class="form-control"
            placeholder="Concentración"
            v-model="data_detail.name"
          />
        </div>
      </div>
    </div>

    <template #footer>
      <button
        class="btn btn-success btn-sm"
        @click="DataDetail"
        :disabled="cpButton"
      >
        {{ num == 0 ? "Registrar" : "Editar" }}
      </button>
      &nbsp;
    </template>
    <SweetAlert :swal="swal" ref="SweetAlert" />
  </CModal>
</template>


<script>
import CModal from "../../../shared/modals/CModal.vue";
import SweetAlert from "@/components/shared/SweetAlert/SweetAlert.vue";
import { mapActions } from "vuex";

export default {
  name: "c-maintenance-modal-servicioEsp",
  components: {
    CModal,
    SweetAlert,
  },
  data() {
    return {
      swal: null,
      data_detail: {
        categorie_id: "",
        subcategorie_id: "",
        name: "",
        specialty_id: "",
        insurance_contrat_id: "",
        kairos: 0.0,
        unidad: 0,
        particular: 0.0,
        eps: true,
        parti: true,
      },
      dataSubSub: [],
    };
  },
  watch: {
    payload: {
      handler(newVal) {
        if (this.num == 1) {
          if (newVal) {
            this.data_detail = {
              categorie_id: "",
              subcategorie_id: "",
              name: "",
              specialty_id: "",
              insurance_contrat_id: "",
              kairos: 0.0,
              unidad: 0,
              particular: 0.0,
              eps: true,
              parti: true,
            };
            this.fetchSubcategoriesEdit();
          }
        }
      },
      immediate: true,
    },
  },
  props: {
    title: String,
    boo_modal: Boolean,
    num: Number,
    payload: {
      type: Object,
      default: null,
    },
    dataCategories: {
      type: Array,
      default: null,
    },
    dataSpecialtys: {
      type: Array,
      default: null,
    },
    dataContracts: {
      type: Array,
      default: null,
    },
  },
  computed: {
    cpButton() {
      return (
        this.data_detail.name.trim() == "" ||
        this.data_detail.categorie_id == "" ||
        this.data_detail.categorie_id == null ||
        this.data_detail.subcategorie_id == "" ||
        this.data_detail.subcategorie_id == null
      );
    },
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdClose() {
      this.data_detail = {
        categorie_id: "",
        subcategorie_id: "",
        name: "",
        specialty_id: "",
        insurance_contrat_id: "",
        kairos: 0.0,
        unidad: 0,
        particular: 0.0,
        eps: true,
        parti: true,
      };
      (this.dataSubSub = []), this.$emit("closeModal");
    },
    DataDetail() {
      this.$emit("Datadetail", this.data_detail, this.num);
      //this.mtdClose();
    },

    mtdChangeStateEps: function () {
      this.Subsubcategory.eps = this.Subsubcategory.eps == 1 ? 0 : 1;
    },
    mtdChangeStateParti: function () {
      this.Subsubcategory.parti = this.Subsubcategory.parti == 1 ? 0 : 1;
    },

    validateInput(field) {
      if (this.data_detail[field] < 0) {
        this.data_detail[field] = 0;
      }
    },

    fetchSubcategoriesEdit() {
      let categoryId = this.data_detail.categorie_id;
      let selectedCategory = this.dataCategories.find(
        (item) => item.id == categoryId
      );
      if (selectedCategory) {
        this.dataSubSub = selectedCategory.subcategorie;
        //this.data_detail.subcategorie_id = '';
      } else {
        this.dataSubSub = [];
        this.data_detail.subcategorie_id = "";
      }
    },

    fetchSubcategories() {
      let categoryId = this.data_detail.categorie_id;
      let selectedCategory = this.dataCategories.find(
        (item) => item.id == categoryId
      );
      if (selectedCategory) {
        this.dataSubSub = selectedCategory.subcategorie;
        this.data_detail.subcategorie_id = "";
      } else {
        this.dataSubSub = [];
        this.data_detail.subcategorie_id = "";
      }
    },

    mtdModalCategory() {
      this.$emit("mtdModalOpenCat");
    },

    mtdModalSubCate() {
      this.$emit("mtdModalOpenSub");
    },
  },
};
</script>